import PropTypes from 'prop-types';

const BulkActionsToolbar = ({ count, itemLabel, onAnalyze, onBalance, onCopy, onDelete, pending = false }) => {
  const label = count === 1 ? itemLabel : `${itemLabel}s`;

  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-3 rounded-md border border-gray-200 bg-gray-50 px-4 py-3">
      <label className="flex items-center gap-3 text-sm text-gray-700">
        <span>
          {count} {label} selected
        </span>
      </label>
      <div className="flex flex-wrap items-center gap-2">
        {onBalance && (
          <button type="button" className="btn btn-ghost btn-sm" onClick={onBalance} disabled={pending}>
            Balance selected
          </button>
        )}
        {onAnalyze && (
          <button type="button" className="btn btn-ghost btn-sm" onClick={onAnalyze} disabled={pending}>
            Analyze selected
          </button>
        )}
        <button type="button" className="btn btn-ghost btn-sm" onClick={onCopy} disabled={pending}>
          Copy selected
        </button>
        {onDelete && (
          <button type="button" className="btn btn-ghost btn-sm text-error" onClick={onDelete} disabled={pending}>
            Delete selected
          </button>
        )}
      </div>
    </div>
  );
};

BulkActionsToolbar.propTypes = {
  count: PropTypes.number.isRequired,
  itemLabel: PropTypes.string.isRequired,
  onAnalyze: PropTypes.func,
  onBalance: PropTypes.func,
  onCopy: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  pending: PropTypes.bool,
};

export default BulkActionsToolbar;
